<template>
<div class="component">

    <div class="columns is-mobile is-multiline">

        <div class="column is-12 filelist projectFileArea">
            <div class="columns is-mobile is-multiline ">
                <div @click="closeFileView()" :class="{'is-10':files.length>=3}" class="wwTitle is-size-2 column is-5-desktop is-12-mobile is-12-tablet is-offset-1-desktop has-text-right-desktop">
                    <div class="button is-size-4" :class="{'is-fullwidth':files.length>=3}">Übersicht</div>
                </div>
                <div class="has-text-center  column  is-6-desktop is-12-mobile is-12-tablet  has-text-center-tablet has-text-left-desktop has-text-left-fullwidth ">
                    <div class="button is-size-4  " @click="addFile=true" v-if="files.length<3">Datei hinzufügen</div>
                </div>
            </div>
            <div class="columns is-mobile is-multiline">
                <div class="column is-4-desktop is-12-mobile is-4-tablet" v-for="file in files">
                    <div class="button" :class="{'is-info':selectedFile==file.id}" @click="selectedFile=file.id">{{getSimpleProjectDate(file.updated_at)}}</div>
                </div>
            </div>

            <div class="fileList columns is-mobile is-multiline">
                <fileOverview @refreshFileList="getProjectFiles()" class="column column is-12-widescreen is-12-mobile is-12-desktop is-12-tablet" v-if="file.id == selectedFile" v-for="file in files" :file="file" />

            </div>
        </div>

    </div>

    <newUserModal @refresh="getProjectDetails()" :projectId="projectId" :isActive="addNewUser" @close="closeNewUserModal()" />
    <addFile @refresh="getProjectFiles()" :areaId="areaId" :isActive="addFile" @close="closeNewFIleModal()" />
    <loadingscreen v-if="isLoading" />

</div>
</template>

<script>
import newUserModal from '@/components/addUser.vue'
import fileOverview from '@/components/fileOverview.vue'
import addFile from '@/components/addFile.vue'

export default {
    name: 'AreaFiles',
    props: ["id", "projectId"],
    components: {
        newUserModal,
        fileOverview,
        addFile
    },
    mounted: function () {
        this.areaId = this.id;
        this.getProjectFiles();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            areaId: 0,
            project: null,
            files: null,
            addNewUser: false,
            addFile: false,
            selectedFile: -1,
            isLoading: false,

        }
    },
    methods: {

        closeNewFIleModal() {
            this.addFile = false
        },
        getProjectFiles() {
            this.files = null;
            this.isLoading = true;
            let postData = {
                "areaId": this.areaId,
            }
            this.callApi("/file/all", "post", postData).then(function (response) {
                this.files = response.data.files
                                this.isLoading = false;

                if (files.length > 0) {
                    this.selectedFile = files[0].id

                }
                this.isLoading = false;

            }.bind(this)).catch(function (error) {
                this.isLoading = false;
            })
        },
        getSimpleProjectDate(date) {

            var datestring = date.split(".")[0];
            datestring = datestring.replace("T", " ");
            return datestring;
        },
        closeFileView() {
            this.$emit("close")
        }

    },
    computed: {},
    watch: {
        id: function (newVal, oldVal) {
            this.closeNewFIleModal();
            this.areaId = newVal;
            this.getProjectFiles();

        },

    }
}
</script>

<style scoped>
.projectTitleArea {
    border-bottom: 1px solid #d9d9d9;
}

.projectFileArea {
    border-right: 1px solid #d9d9d9;

}
</style>
